import React, { useEffect, useState } from 'react';
import PasswordGate, { isAuthenticated } from './components/PasswordGate';
import Overview from './components/Overview';
import SignalsFeed from './components/SignalsFeed';
import { usePoll, Health, marketOpen } from './lib';

type View = 'overview' | 'signals';

function UtcClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const p = (n: number) => String(n).padStart(2, '0');
  return (
    <span className="clock" title="UTC">
      {p(now.getUTCHours())}:{p(now.getUTCMinutes())}
      <span className="clock-s">:{p(now.getUTCSeconds())} UTC</span>
    </span>
  );
}

export default function App() {
  const [authed, setAuthed] = useState(isAuthenticated());
  const [view, setView] = useState<View>('overview');
  const { data: health, err } = usePoll<Health>('health', 60000);

  if (!authed) return <PasswordGate onAuth={() => setAuthed(true)} />;

  const live = !err && health?.status === 'healthy';
  const open = marketOpen();

  return (
    <div className="sheet">
      <header className="masthead">
        <div className="masthead-left">
          <span className="wordmark">
            NEWSTECH<span className="wordmark-tick">▼</span>
          </span>
          <span className="subtitle">short-side news desk</span>
        </div>
        <nav className="tabs" aria-label="views">
          <button
            className={view === 'overview' ? 'tab on' : 'tab'}
            onClick={() => setView('overview')}
          >
            Overview
          </button>
          <button
            className={view === 'signals' ? 'tab on' : 'tab'}
            onClick={() => setView('signals')}
          >
            Signals
          </button>
        </nav>
        <div className="masthead-right">
          <span className={open ? 'chip chip-open' : 'chip'}>
            {open ? 'MARKET OPEN' : 'MARKET CLOSED'}
          </span>
          <span className={live ? 'dot live' : 'dot dead'} title={live ? 'system healthy' : 'api unreachable'} />
          <UtcClock />
        </div>
      </header>

      {view === 'overview' ? <Overview /> : <SignalsFeed />}

      <footer className="colophon">
        <span>the-method / paper account</span>
        <span>
          {health?.ingestion?.last_ingestion
            ? `last ingest ${new Date(health.ingestion.last_ingestion).toISOString().slice(11, 16)}z`
            : '—'}
        </span>
      </footer>
    </div>
  );
}
